import { render, staticRenderFns } from "./admin_vue.vue?vue&type=template&id=4f997edd&scoped=true&"
import script from "./admin_vue.vue?vue&type=script&lang=js&"
export * from "./admin_vue.vue?vue&type=script&lang=js&"
import style0 from "./admin_vue.vue?vue&type=style&index=0&id=4f997edd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f997edd",
  null
  
)

export default component.exports